// extracted by mini-css-extract-plugin
export default {"ny__dish__counter-container":"ny__dish__counter-container___JKczS","visible":"visible___CuSR0"};